import React from "react";
import { Col, Row } from "reactstrap";
import { Button } from "shared";
import { SiteComparisonControlProps } from "./type";
import "./index.scss";

const SiteComparisonControl = ({
  getNearbyAndSisterStore,
  saveCurrentComparisonHistory,
  toggleCompetitorSelectionModal,
}: SiteComparisonControlProps) => {
  return (
    <Row>
      <Col xs={12}>
        <h4 className="site-comparison-title">So sánh mặt bằng</h4>
      </Col>
      <Col xs={12}>
        <div className="site-comparison-controls">
          <Button
            customClassName="site-comparison-button"
            type="primary"
            outline
            label="Lấy store gần nhất và store sister"
            onClick={getNearbyAndSisterStore}
            size="small"
          />
          <Button
            customClassName="site-comparison-button"
            type="primary"
            outline
            label="Lấy store đối thủ"
            onClick={toggleCompetitorSelectionModal}
            size="small"
          />
          <Button
            customClassName="site-comparison-button"
            type="primary"
            label="Lưu kết quả hiện tại"
            onClick={saveCurrentComparisonHistory}
            size="small"
          />
        </div>
      </Col>
    </Row>
  );
};

export default SiteComparisonControl;
